import { groupBy, orderBy } from "lodash";
import { EPaymentOrderType } from "../types/payment.types";
import { EPropertyMemberTypes } from "../types/property.types";
import { getLocalizedText } from "./i18n/i18n.utils";
export var PAYMENT_ORDER_SORTING = [
    EPaymentOrderType.Rent,
    EPaymentOrderType.CommonCosts,
    EPaymentOrderType.NonCommonCosts,
    EPaymentOrderType.ManagementCosts,
    EPaymentOrderType.Rentio,
    EPaymentOrderType.OtherRecurring,
    EPaymentOrderType.LocationDescription,
    EPaymentOrderType.BrokerFee,
    EPaymentOrderType.OtherOneoff,
    EPaymentOrderType.RentDiscount,
    EPaymentOrderType.IndexationCorrectionRent,
    EPaymentOrderType.IndexationCorrectionCommonCosts,
    EPaymentOrderType.IndexationCorrectionNonCommonCosts,
    EPaymentOrderType.IndexationCorrectionManagementCosts,
    EPaymentOrderType.IndexationCorrectionRentio,
    EPaymentOrderType.IndexationCorrectionOtherRecurring,
    EPaymentOrderType.IndexationRetroactiveRent,
    EPaymentOrderType.IndexationRetroactiveCommonCosts,
    EPaymentOrderType.IndexationRetroactiveNonCommonCosts,
    EPaymentOrderType.IndexationRetroactiveManagementCosts,
    EPaymentOrderType.IndexationRetroactiveRentio,
    EPaymentOrderType.IndexationRetroactiveOtherRecurring,
    EPaymentOrderType.RentDeposit,
    EPaymentOrderType.RentDepositPayout,
];
Object.values(EPaymentOrderType).forEach(function (type) {
    if (type === EPaymentOrderType.RentAndCosts) {
        return;
    }
    if (!PAYMENT_ORDER_SORTING.includes(type)) {
        throw new Error("Payment order type ".concat(type, " is not in the sorting array"));
    }
});
export var getTitle = function (_a) {
    var otherDescription = _a.otherDescription, type = _a.type;
    if (otherDescription) {
        if (type.includes(EPaymentOrderType.IndexationCorrectionRent)) {
            return getLocalizedText("payment.payment_order.type.".concat(EPaymentOrderType.IndexationCorrectionRent, "_other").toLowerCase(), { description: otherDescription });
        }
        if (type.includes(EPaymentOrderType.IndexationRetroactiveRent)) {
            return getLocalizedText("payment.payment_order.type.".concat(EPaymentOrderType.IndexationRetroactiveRent, "_other").toLowerCase(), { description: otherDescription });
        }
        return otherDescription;
    }
    return getLocalizedText("payment.payment_order.type.".concat(type).toLowerCase());
};
var sortPaymentOrdersByType = function (input) {
    return orderBy(input, [
        function (x) { return PAYMENT_ORDER_SORTING.indexOf(x.type); },
        "createdAt",
        "id",
    ]);
};
export var groupPaymentOrdersByContractV2 = function (paymentOrders) {
    var paymentOrdersGroupedByContractId = Object.values(groupBy(paymentOrders, function (x) { var _a; return ((_a = x.contractInfo) === null || _a === void 0 ? void 0 : _a.relatedContractId) || x.contractId; }));
    var paymentOrdersGroupedByPaymentGroupId = paymentOrdersGroupedByContractId.map(function (paymentOrders) {
        return Object.values(groupBy(paymentOrders, function (x) { return x.paymentGroupId; }));
    });
    var result = paymentOrdersGroupedByPaymentGroupId.map(function (x) {
        return {
            contractInfo: x[0][0].contractInfo,
            paymentOrders: x.map(function (y) { return ({
                paymentGroupId: y[0].paymentGroupId,
                paymentOrders: sortPaymentOrdersByType(y),
            }); }),
        };
    });
    // Sort groups by contract start date
    return orderBy(result, function (group) { var _a; return (_a = group.contractInfo) === null || _a === void 0 ? void 0 : _a.startDate; });
};
export var groupPaymentOrdersByContract = function (paymentOrders) {
    var paymentOrdersGroupedByContractId = Object.values(groupBy(paymentOrders, function (paymentOrder) { var _a; return ((_a = paymentOrder.contract) === null || _a === void 0 ? void 0 : _a.relatedContractId) || paymentOrder.contractId; }));
    var paymentOrdersGroupedByPaymentGroupId = paymentOrdersGroupedByContractId.map(function (paymentOrders) {
        return Object.values(groupBy(paymentOrders, function (x) { return x.paymentGroupId; }));
    });
    var result = paymentOrdersGroupedByPaymentGroupId.map(function (x) {
        return {
            contract: x[0][0].contract,
            paymentOrders: x.map(function (y) { return ({
                paymentGroupId: y[0].paymentGroupId,
                paymentOrders: sortPaymentOrdersByType(y),
            }); }),
        };
    });
    // Sort groups by contract start date
    var orderedResult = orderBy(result, function (group) { var _a; return (_a = group.contract) === null || _a === void 0 ? void 0 : _a.startDate; });
    return orderedResult;
};
export var canAddPaymentOrders = function (params) {
    var isBroker = params.isBroker, property = params.property;
    return (isBroker || property.roles.includes(EPropertyMemberTypes.FinancialManager));
};
